export const GET_CART = "cart/get";
export const ADD_TO_CART = "cart/add";
export const ITEM_EXIST = "cart/exist";
export const UPDATE_CART = "cart/update";
export const DELETE_FROM_CART = "cart/delete";
